export function getNameLetters(name: string): string {
    const parts = name.split(" ");
    if (parts.length === 1) return name.substring(0, 2);
    return parts
        .slice(0, 2)
        .map((p) => p[0])
        .join("");
}
